/**
 * LG Channel Vietnam 업로드 접근 규칙 (rule-based).
 *
 * BE가 권한을 3계층으로 분리했고 프론트는 그 계약을 그대로 읽는다
 * (BE 브랜치 `feature/lg-channel-vietnam-role-permission`).
 *
 * | 계층 | BE 판정 | 프론트 |
 * |---|---|---|
 * | 진입 자격 | `user.is_lg_channel_vietnam` OR `company.is_lg_channel_vietnam` | `accountStore.isLgChannelVietnam()` |
 * | 행위 권한 | role → permission code | 아래 CODE 상수 + `hasPermissionCode()` |
 * | 데이터 스코프 | 서버가 company로 강제 (admin role은 조회만 전 CP 우회) | **판정하지 않는다** |
 *
 * AS-IS였던 `platform.id === 3` 판정은 삭제됐다. platform은 테넌트 경계이지 권한 단위가 아니고,
 * VN CP도 ODK platform(id=1)으로 통합됐다. 자격 목록이 env가 아니라 DB에 있으므로
 * 재배포 없이 어드민에서 부여/회수한다.
 *
 * 데이터 스코프를 프론트가 판정하지 않는 것이 이 설계의 핵심이다. 목록 엔드포인트는 하나이고
 * 서버가 호출자에 따라 자기 company / 전 CP를 결정한다. 따라서 프론트는 "내가 운영진인가"를
 * 알 필요가 없고, 응답에 company가 섞여 오면 그때 Company 컬럼을 노출하면 된다.
 */

/**
 * permission code 형식 주의: 기존 어드민 권한은 `{menu}:{action}` 콜론 표기지만
 * 이 3건은 BE 시드가 `{app}.{action}` 점 표기로 등록했다
 * (`authorization/migrations/0002_seed_vietnam_upload_permissions.py`).
 * 그래서 `hasPermission(menu, action)`이 아니라 `hasPermissionCode(code)`로 확인해야 한다.
 */
export const VIETNAM_UPLOAD_VIEW_CODE = 'vietnam_upload.view';
export const VIETNAM_UPLOAD_UPLOAD_CODE = 'vietnam_upload.upload';
export const VIETNAM_UPLOAD_INGEST_CODE = 'vietnam_upload.ingest';

/** 세 code를 묶어 부여하는 BE role 이름. 운영에서 계정에 수동 부여한다. */
export const LG_CHANNEL_VIETNAM_ROLE = 'lg_channel_vietnam';

/** 사이드바 메뉴 키 — 업로드 목록 (`/vietnam-uploads`). `vietnam_upload.view`에서 유도. */
export const VIETNAM_UPLOADS_MENU = 'vietnam-uploads';

/** 사이드바 메뉴 키 — VN 업로드 화면 (`/assets/add-vn`). `vietnam_upload.upload`에서 유도. */
export const VIETNAM_UPLOAD_NEW_MENU = 'vietnam-upload-new';

/**
 * VN 전용 계정이 호출할 수 있는 API prefix. BE `ScopedJWTAuthentication.ALLOWED_PREFIXES`와
 * 같은 값이며, 이 목록 밖은 403이다.
 *
 * 사이드바에 다른 도메인 메뉴를 노출하면 클릭하는 즉시 403이므로,
 * `accountStore.getMenus()`가 VN 전용 계정에게는 account 계열 + VN 메뉴만 남긴다.
 */
export const VIETNAM_ALLOWED_API_PREFIXES = ['/api/v1/vietnam-upload/', '/api/v1/accounts/'];
